import React from "react";

import { ISelectedNetworkContext, INetworksContext } from "./types";

export const SelectedNetworkContext = React.createContext(
  {} as ISelectedNetworkContext
);
export const NetworksContext = React.createContext({} as INetworksContext);

export function useSelectedNetworkContext() {
  const context = React.useContext(SelectedNetworkContext);

  if (!context) {
    throw new Error(
      "useSelectedNetworkContext must be inside SelectedNetworkProvider"
    );
  }

  return context;
}

export function useNetworkContext() {
  const context = React.useContext(NetworksContext);

  if (!context) {
    throw new Error("useNetworkContext must be inside NetworksProvider");
  }

  return context;
}
